import _ from 'lodash'

export function isNumeric (value) {
  return (_.isNumber(value) || (_.isString(value) && Boolean(value.trim()))) && isFinite(value)
}



// WEBPACK FOOTER //
// ./src/helpers/types.js